import { useCallback } from "react";
import Button from "../Button";
import { Alert } from "../Alert";
import { useI18n } from "../../hooks/i18n-hooks";
import { RNSwipeButtonProps } from "./SwipeButton";

export const SwipeButton = ({
    title = "",
    onSwipeSuccess,
    disabled,
    mode,
    ...props
}: RNSwipeButtonProps) => {
    const i18n = useI18n();

    const onPressButton = useCallback(() => {
        Alert.alert(
            title,
            i18n.t("confirm"),
            [
                {
                    text: i18n.t("screens.user.timesheet_review.reject_alert.confirm"),
                    onPress: () => {
                        if (onSwipeSuccess) {
                            void onSwipeSuccess();
                        }
                    },
                    style: "default",
                },
                {
                    text: i18n.t("screens.user.timesheet_review.reject_alert.cancel"),
                    style: "cancel",
                },
            ],
            { cancelable: true },
        );
    }, [i18n, onSwipeSuccess, title]);

    return (
        <Button
            onPress={onPressButton}
            disabled={disabled}
            buttonMode={mode}
            label={title}
            {...props}
        />
    );
};
